import { render } from "./AddRecord.vue?vue&type=template&id=6529320a&scoped=true"
import script from "./AddRecord.vue?vue&type=script&lang=js"
export * from "./AddRecord.vue?vue&type=script&lang=js"

import "@/components/modal-responsive.css?vue&type=style&index=0&id=6529320a&scoped=true&lang=css&external"
import "./AddRecord.vue?vue&type=style&index=1&id=6529320a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6529320a"]])

export default __exports__